import ChildrenBlock from '../ChildrenBlock';
import React from 'react';
import classnames from 'classnames';


export const Columns = ({ verticalAlignment }: {verticalAlignment?: string}) => {
    const className = classnames( {
        [`wp-block-columns`]: true,
        [ `are-vertically-aligned-${ verticalAlignment }` ]: verticalAlignment,
    } );

    return <div className={className}>
        <ChildrenBlock/>
    </div>
}